export const cleoBeforeImage = {
  src: "/images/landingPage/SuccessStories/cleo_before.webp",
  width: 158,
  height: 202,
};

export const cleoAfterImage = {
  src: "/images/landingPage/SuccessStories/cleo_after.webp",
  width: 158,
  height: 202,
};

export const cheeseBeforeImage = {
  src: "/images/landingPage/SuccessStories/cheese_before.webp",
  width: 154,
  height: 198,
};

export const cheeseAfterImage = {
  src: "/images/landingPage/SuccessStories/cheese_after.webp",
  width: 155,
  height: 197,
};
